/***
 * Created on 2025/3/5
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import disconnect_svg from '../static/img/illustration/illustration-facebook-disconnect.png';
import {useTranslation} from "react-i18next";

function DeleteFacebookStatus(props) {
    const {t} = useTranslation();

    const onClick = () => {
        location.href = '/';
    }

    return (
        <section className="common-page-wrapper common-page-wrapper--sns-disconnect">
            <div className="common-page-body">
                <div className="sns-disconnect--infographic">
                    <div className="sns-disconnect--infographic__source">
                        <img src={disconnect_svg} alt="Facebook Disconnect"/>
                    </div>
                </div>
                <div className="sns-disconnect--info">
                    <p className="font-medium text-26 line-height-25 !mb-24">{t('@Facebook Unlinked Successfully@')}</p>
                    <p className="text-15 !mb-40">{t('@Your account has been successfully unlinked from Facebook. All Facebook-related data, including your avatar, has been removed. You can still sign in with your QNAP ID and password, but all active sessions have been logged out, requiring you to sign in again.@')}</p>
                    <button className="q-btn q-btn--primary btn-medium btn-rounded-full !w-fit mt24" onClick={onClick}>{t('@Home@')}</button>
                </div>
            </div>
        </section>
    );
}

export default DeleteFacebookStatus;